import { ComponentRef, Injectable } from '@angular/core';
import { AbcCore } from '@barthauer/abc/core';
import { tap } from 'rxjs/operators';

import { AbcPopupComponent } from '../abc-popup';
import { AbcCoreComponent } from '../abcCoreComponent';
import { AbcCoreContainerService } from '../abcCoreContainer.service';
import { AbcCameraDetailsComponent } from './abc-camera-details.component';

@Injectable({ providedIn: 'root' })
export class AbcCameraDetailsService {
  private abcCamerDetailsCptRef: ComponentRef<AbcCameraDetailsComponent>;
  private CameraDetailsPopup: AbcPopupComponent;
  private CameraDetailsContainer: AbcCoreComponent;

  constructor(
    private coreContainerService: AbcCoreContainerService,
    private abcCore: AbcCore,
  ) {}

  public async openCameraDetails(
    title: string,
    insertImage: (filename: string, dataUrl: string) => void,
    settings?: CameraPopupSettings,
  ): Promise<void> {
    await this.createCameraDetailsComponent(title, settings);

    this.abcCamerDetailsCptRef = this.CameraDetailsPopup.openPopUp() as ComponentRef<AbcCameraDetailsComponent>;
    this.abcCamerDetailsCptRef.instance.insertImage = insertImage;
    this.abcCamerDetailsCptRef.instance.onClose.subscribe(() => {
      this.destroyCameraDetailsComponent();
    });

    try {
      await this.CameraDetailsPopup.onHiding
        .asObservable()
        .pipe(
          tap(() => {
            this.destroyCameraDetailsComponent();
          }),
        )
        .toPromise();
    } catch (err) {
      this.abcCore.error.publish(err);
    }
  }

  private async createCameraDetailsComponent(title: string, settings?: CameraPopupSettings): Promise<void> {
    if (!this.CameraDetailsPopup) {
      this.CameraDetailsContainer = this.coreContainerService.createComponent(
        this.CameraDetailsContainer,
        AbcPopupComponent,
      );
      this.CameraDetailsPopup = this.CameraDetailsContainer.componentRef.instance as AbcPopupComponent;
      this.CameraDetailsPopup.component = AbcCameraDetailsComponent;
      this.CameraDetailsPopup.resizeEnabled = true;
      this.CameraDetailsPopup.showCloseButton = true;
      this.CameraDetailsPopup.title = title;
      this.CameraDetailsPopup.width = settings?.cameraPopupWidth ? settings?.cameraPopupWidth : '90dvw';
      this.CameraDetailsPopup.height = settings?.cameraPopupHeight ? settings?.cameraPopupHeight : '90dvh';
      this.CameraDetailsPopup.minWidth = settings?.cameraPopupMinWidth ? settings?.cameraPopupMinWidth : '350px';
      this.CameraDetailsPopup.minHeight = settings?.cameraPopupMinHeight ? settings?.cameraPopupMinHeight : '450px';
      this.CameraDetailsPopup.maxWidth = settings?.cameraPopupMaxWidth ? settings?.cameraPopupMaxWidth : '450px';
      this.CameraDetailsPopup.maxHeight = settings?.cameraPopupMaxHeight ? settings?.cameraPopupMaxHeight : '650px';
    }
  }

  public async destroyCameraDetailsComponent(): Promise<void> {
    this.CameraDetailsPopup && this.CameraDetailsPopup.instance.dispose();
    this.CameraDetailsPopup && this.CameraDetailsPopup.ngOnDestroy();
    this.CameraDetailsContainer.componentRef.destroy();
    this.abcCamerDetailsCptRef.destroy();
    this.CameraDetailsPopup = undefined;
    this.CameraDetailsContainer = undefined;
  }
}

export class CameraPopupSettings {
  cameraPopupWidth: string;
  cameraPopupHeight: string;
  cameraPopupMaxHeight: string;
  cameraPopupMinHeight: string;
  cameraPopupMaxWidth: string;
  cameraPopupMinWidth: string;
}
